var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialist4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ededed;}.b{clip-path:url(#a);}.c{fill:#621ac0;}.d{fill:#fff;}.e{opacity:0.1;}.f{fill:#40596b;}.g{fill:#3a2c60;}.h{fill:#ff8f00;}.i{fill:#f2f2f2;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 102,
    height: 102,
    rx: 50,
    transform: "translate(511 339)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-511 -339)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 102,
    height: 102,
    rx: 50,
    transform: "translate(511 339)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(517.331 351.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M89.339,360.931v13.438H0V360.931a8.62,8.62,0,0,1,5.489-8.04l18.837-7.408,14.7,16.157,4.614-9.4v-.019l1.025-2.1,1.044,2.105,4.616,9.418,14.683-16.157,18.856,7.408a8.651,8.651,0,0,1,5.47,8.04",
    transform: "translate(0 -284.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M206.7,293.064h.019v-7.65a41.211,41.211,0,0,1-3.432,4.489l-1.824,2.01a8.915,8.915,0,0,1-6.533,2.885h-2.792a8.9,8.9,0,0,1-6.533-2.885l-1.824-2.01a40.457,40.457,0,0,1-3.464-4.538v7.685l.03.015,11.484,6.477,1.694.949,1.694-.949Z",
    transform: "translate(-148.857 -234.771)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(39.806 50.682)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M228.284,294.53l-.033-.011c-.019-.007-.039-.013-.058-.019s-.039-.011-.065-.02l7.019,5.213,11.022-6.217h.011l.008-7.611c-.019.028-2.617,3.432-3.432,4.447l-1.824,2.012a8.915,8.915,0,0,1-6.533,2.885h-2.792a7.943,7.943,0,0,1-1.658-.177,8.623,8.623,0,0,1-1.664-.5",
    transform: "translate(-228.128 -285.866)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.271 29.356)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M141.7,169.347c.29,3.341-1.331,6.213-3.62,6.41s-4.387-2.347-4.683-5.688,1.331-6.209,3.624-6.41,4.389,2.345,4.679,5.688",
    transform: "translate(-133.364 -163.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M339.111,170.082c-.29,3.341-2.388,5.887-4.679,5.686s-3.916-3.069-3.62-6.41,2.388-5.889,4.679-5.688,3.914,3.069,3.62,6.412",
    transform: "translate(-296.33 -163.657)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.78,56.895a36.513,36.513,0,0,1-9.23,20.062l-1.824,2.01a8.91,8.91,0,0,1-6.533,2.887H163.4a8.9,8.9,0,0,1-6.533-2.887l-1.824-2.01a36.672,36.672,0,0,1-9.233-20.062,72.145,72.145,0,0,1,0-13.4,19.247,19.247,0,0,1,37.969,0,72.17,72.17,0,0,1,0,13.4",
    transform: "translate(-120.117 -21.829)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M134.171,10.288s.13-12.532,18.35-8.528A31.537,31.537,0,0,1,167.377,13s5.457,7.925,2.49,14.592c-.964,2.165-2,4.642-1.88,6.631,0,0-1.011-4.223-1.614-7.743a16.476,16.476,0,0,0-3.722-7.977l-.058-.069a12.757,12.757,0,0,0-12.762-4.158,22.922,22.922,0,0,0-7.551,3.687s-7.59-5.094-11.342,3.823A47.946,47.946,0,0,0,129.5,33.455s-10.447-21.875,4.668-23.167",
    transform: "translate(-104.003 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M339.165,331.683c-.037-.316-.11-3.218-.705-4.391a6.674,6.674,0,0,0-4.988-3.629l-5.993-1.21v1.228h-.019l-.858.484,6.572,1.34a4.77,4.77,0,0,1,3.611,2.622,4.7,4.7,0,0,1,.5,2.868l-.039.484c-7.873,6.831-10.106,12.991-10.2,13.271-.592,1.768-.556,3.164.095,4.169a2.874,2.874,0,0,0,2.064,1.284l.186-1.861a1.075,1.075,0,0,1-.705-.465,3.22,3.22,0,0,1,.13-2.515,27.67,27.67,0,0,1,4.467-7.168,3.989,3.989,0,0,1,5.267,1.562,28.428,28.428,0,0,1-.465,8.563c-.355,1.154-.839,1.917-1.377,2.122a.908.908,0,0,1-.821-.037l-.465.817-.484.806a2.824,2.824,0,0,0,1.415.372,2.557,2.557,0,0,0,1.007-.2c1.117-.426,1.975-1.545,2.529-3.332.076-.279,1.805-6.776-.728-17.181m-2.472,4.821a5.44,5.44,0,0,0-1.716-.221c.8-.877,1.694-1.768,2.7-2.678.279,1.3.484,2.548.633,3.722a5.525,5.525,0,0,0-1.617-.823",
    transform: "translate(-269.613 -265.387)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.251 82.585)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M341.548,470.332a1.386,1.386,0,0,1-1.625,1.089c-.745-.147-.214-2.859.534-2.712a1.384,1.384,0,0,1,1.091,1.623",
    transform: "translate(-339.565 -468.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M367.63,479.552a1.382,1.382,0,0,0,.679,1.831c.694.318,1.846-2.192,1.152-2.513a1.383,1.383,0,0,0-1.831.681",
    transform: "translate(-362.629 -476.992)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M106.713,323.671l-.03-.015v-1.214l-4.024.828a14.441,14.441,0,0,0-10.313,19.954l1.7-.748a12.579,12.579,0,0,1,8.98-17.38l4.547-.936Z",
    transform: "translate(-75.221 -265.379)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.326 58.274)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.343,332.187,262.609,350.2,256,336.821l1.694-.949,11.484-6.477h.019l.018-.019Z",
    transform: "translate(-235.657 -329.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M139.413,332.187,153.169,350.2l6.587-13.382-1.694-.949-11.484-6.477-.037-.019Z",
    transform: "translate(-139.413 -329.376)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M218.251,396.295l3.758-8.561-1.621-2.383-1.187-1.787,4.612-9.416,1.025-2.105,1.044,2.105v.018l4.616,9.4-1.21,1.77-1.621,2.4,3.78,8.561Z",
    transform: "translate(-180.168 -306.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M234.989,383.564l-1.21,1.77-4.432-9.066-4.469,9.083-1.187-1.787,4.612-9.416,1.025-2.105,1.044,2.105v.018Z",
    transform: "translate(-184.659 -306.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M95.215,438.316A4.216,4.216,0,1,1,91,434.1a4.219,4.219,0,0,1,4.218,4.214",
    transform: "translate(-71.641 -357.555)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M100.374,444.858a2.832,2.832,0,1,1-2.829-2.831,2.829,2.829,0,0,1,2.829,2.831",
    transform: "translate(-78.184 -364.097)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M103.542,448.873a1.984,1.984,0,1,1-1.98-1.982,1.982,1.982,0,0,1,1.98,1.982",
    transform: "translate(-82.199 -368.112)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialist4);
export default __webpack_public_path__ + "static/media/specialist4.9e11e3be191e773499374dbe5f33059c.svg";
export { ForwardRef as ReactComponent };